module.exports = __webpack_public_path__ + "img/bg_genesight_nucleotide.86039a10.png";